import { HxChildMap } from "../../../../Comps/HxMap/HxChildMap"
import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { BuildHexMap, HexMapBuilder, HexMapBuilderParams } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { All } from "../../../../Util/Constants/Quantities"
import { Music } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"

export function CycleOfFifthsMap(){
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:14, columns:9, tonic:Music.D, radius:25}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], false)
        mod.keys_setHilited([7,109])
        mod.keys_setSelected([15,24,32,41,49,58,66,75,83,92,100])
        return map
    }
    const map:HexMap = getMap()
    const [width,height] = [500,600]
    return(
        <div>
            <svg width={width} height={height}>
                <g transform={TransformTranslate(width/2, height/2)}>
                    <HxMapGroup hexMap={map}/>
                </g>
            </svg>
        </div>
    )
}